const stripTrailingSlash = value => value.replace(/\/+$/, "");

const stripApiSuffix = value => stripTrailingSlash(value).replace(/\/api$/, "");

const getConfiguredBackendUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();

  if ((process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") && configuredUrl) {
    return stripTrailingSlash(configuredUrl);
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }

  return stripTrailingSlash(configuredUrl || "");
};

export const getBackendOrigin = () => stripApiSuffix(getConfiguredBackendUrl());

export const getApiBaseUrl = () => {
  if ((process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") && process.env.REACT_APP_BACKEND_URL?.trim()) {
    return stripApiSuffix(process.env.REACT_APP_BACKEND_URL.trim());
  }

  const backendOrigin = getBackendOrigin();

  return backendOrigin ? `${backendOrigin}/api` : "";
};

export const getPublicUrl = path => {
  const normalizedPath = String(path || "").replace(/^\/+/, "");

  return `${getBackendOrigin()}/${normalizedPath}`;
};